import * as _ from 'lodash'
import { format } from 'date-fns';
import * as React from 'react'
import { Link } from 'react-router-dom';
import { Button, Card } from 'reactstrap';
import { ContentCardHeader } from '../../components/ui/ContentCardHeader';
import { DataGrid, DataGridSortOrder } from '../../components/ui/DataGrid';
import { FontAwesomeIcon } from '../../components/ui/FontAwesomeIcon';
import { GridContainer } from '../../components/ui/Grid';
import { SurveyManagementHttp } from './lib/http';
import { ISurveyManagementClientsIndex, ISurveyManagementFile } from './lib/interfaces';

interface ISurveyFilesContainerState {
  clients: ISurveyManagementClientsIndex[]
  sortBy: keyof ISurveyManagementClientsIndex
  sortOrder: DataGridSortOrder
}

export class SurveyFilesContainer extends React.Component<{}, ISurveyFilesContainerState> {
  state: ISurveyFilesContainerState = {
    clients: [],
    sortOrder: 'asc',
    sortBy: 'dateOfLastFileReceived'
  }

  componentWillMount() {
    this.initClients()
  }

  initClients() {
    SurveyManagementHttp.getClients()
      .then(({ response: clients }) => this.setState({ clients }))
  }

  render() {
    return (
      <section className="blacklight page-bg page-container">
        <GridContainer className="subtleSlideInRight">
          <Card>
            <ContentCardHeader
              sticky
              borderBottom
              header={
                <section className="d-flex justify-content-between">
                  <header>
                    <h2>
                      <span>Clients</span>
                      {this.state.clients.length <= 0 &&
                        <FontAwesomeIcon icon="cog" size="sm" verticalAlign="middle" spin muted />
                      }
                    </h2>
                    <Link to={`/coachingvars`}><Button color="white" className="mr-2"
                    >Coaching Template Rules</Button></Link><Link to={`/fieldvars`}><Button color="white" className="mr-2"
                    >Field Replacement Rules</Button></Link>
                  </header>
                  <footer>
                    {/* <Button color="white"
                      onClick={() => this.endMonth()}>
                      <FontAwesomeIcon icon="calendar-alt" verticalAlign="middle" fixedWidth />
                      <span>End Month</span>
                    </Button> */}
                  </footer>
                </section>
              }
            />

            <DataGrid<ISurveyManagementClientsIndex>
              sortBy={this.state.sortBy}
              sortOrder={this.state.sortOrder}
              onSortChange={(sortBy, sortOrder) => this.setState({ sortBy, sortOrder })}
              records={this.state.clients}
              columns={[
                { property: 'clientName', header: 'Client Name' },
                {
                  property: 'dateOfLastFileReceived', header: 'Last File Received On', render: (record) =>
                    <span>{format(new Date(record.dateOfLastFileReceived), 'MM/dd/yyyy')}</span>
                },
                {
                  header: '', align: 'right', render: (record) =>
                    <Link to={`/process/${record.clientAbbr}`}>
                      <Button type="button" color="primary">
                        <FontAwesomeIcon regular icon="play-circle" fixedWidth verticalAlign="middle" />
                        <span>&nbsp;Begin Processing</span>
                      </Button>
                    </Link>
                },
              ]}
            />

          </Card>
        </GridContainer>
      </section>
    )
  }
}
